export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14578.f4744085.jpg";